module.exports = __webpack_public_path__ + "static/pic02-72142422cf7f7ee7f8b4818d2c58c799.jpg";